import React, { FC } from 'react';
import i18n from '../../../i18n';
import { makeStyles, Theme } from '@material-ui/core/styles';

import { Text, TextTypography } from 'components/Text/Text';

import { HeaderItemCircle } from './HeaderItemCircle';
import { HeaderItemType } from './types';

export interface WizardItemProps {
    index: number;
    text: string;
    type: HeaderItemType;
}

const getTextColor = (theme: Theme, type: HeaderItemType) => {
    switch (type) {
        case HeaderItemType.COMPLETE:
            return theme.palette.fixedPrimary.primary;
        case HeaderItemType.ACTIVE:
            return theme.palette.fixedPrimary.primary;
        case HeaderItemType.DISABLED:
            return theme.palette.fixedPrimary.light;
    }
};

const useStyles = makeStyles(theme => ({
    container: {
        width: theme.spacing(11),
    },
    circleContainer: {
        height: 40,
        textAlign: 'center',
    },
    text: {
        color: ({ type }: any) => getTextColor(theme, type),
        textAlign: 'center',
    },
}));

export const HeaderItem: FC<WizardItemProps> = props => {
    const classes = useStyles(props);
    const { t } = i18n.useTranslation();
    return (
        <div className={classes.container}>
            <div className={classes.circleContainer}>
                <HeaderItemCircle index={props.index} type={props.type} />
            </div>
            <div className={classes.text}>
                <Text typography={TextTypography.CAPTION_ACCENT}>{t(props.text)}</Text>
            </div>
        </div>
    );
};
